<template>
  <div class="mod-mps-capacity">
    <el-alert type="info" show-icon :closable="false" style="margin-bottom:12px"
      title="按已审主生产计划、物料工艺节拍及所属车间估算负荷；峰值负荷率计入同车间重叠期间的所有计划，可用工时按期间天数和每日工时参数计算。" />
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="车间编码"><el-input v-model="q.workShopCode" size="small" clearable /></el-form-item>
      <el-form-item label="期间起"><el-date-picker v-model="q.planStartDate" type="date" value-format="yyyy-MM-dd" size="small" clearable /></el-form-item>
      <el-form-item label="期间止"><el-date-picker v-model="q.planEndDate" type="date" value-format="yyyy-MM-dd" size="small" clearable /></el-form-item>
      <el-form-item><el-button v-if="isAuth('production:mpsCapacityLoad:list')" type="primary" size="small" @click="search">查询</el-button></el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" width="50" />
      <el-table-column prop="workShopCode" label="车间编码" min-width="110" />
      <el-table-column prop="workShopName" label="车间名称" min-width="120" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" />
      <el-table-column prop="periodStart" label="期间起" width="110"><template slot-scope="s">{{ (s.row.periodStart || '').slice(0, 10) || '—' }}</template></el-table-column>
      <el-table-column prop="periodEnd" label="期间止" width="110"><template slot-scope="s">{{ (s.row.periodEnd || '').slice(0, 10) || '—' }}</template></el-table-column>
      <el-table-column prop="plannedQty" label="计划量" width="100" align="right" />
      <el-table-column prop="loadHours" label="负荷(时)" width="100" align="right"><template slot-scope="s">{{ s.row.loadHours == null ? '—' : s.row.loadHours }}</template></el-table-column>
      <el-table-column prop="availableHours" label="可用(时)" width="100" align="right"><template slot-scope="s">{{ s.row.availableHours == null ? '—' : s.row.availableHours }}</template></el-table-column>
      <el-table-column label="峰值负荷率" width="110" align="right">
        <template slot-scope="s">{{ s.row.loadRate == null ? '—' : (Number(s.row.loadRate) * 100).toFixed(1) + '%' }}</template>
      </el-table-column>
      <el-table-column label="超载" width="80" align="center">
        <template slot-scope="s">
          <el-tag v-if="s.row.warning" type="warning" size="mini">缺配置</el-tag>
          <el-tag v-else-if="s.row.overloadFlag === '1'" type="danger" size="mini">超载</el-tag>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column prop="warning" label="提示" min-width="190"><template slot-scope="s">{{ s.row.warning || '—' }}</template></el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-size="20" layout="total, prev, pager, next" :total="total"
      @current-change="p => { pageIndex = p }" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'MpsCapacityLoad',
  data() {
    return {
      q: { workShopCode: '', planStartDate: '', planEndDate: '' }, list: [], loading: false, pageIndex: 1, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  computed: {
    filtered() {
      return this.list.filter(row => {
        const shop = (this.q.workShopCode || '').trim()
        if (shop && String(row.workShopCode || '').indexOf(shop) < 0) return false
        if (this.q.planStartDate && String(row.periodEnd || '') < this.q.planStartDate) return false
        if (this.q.planEndDate && String(row.periodStart || '') > this.q.planEndDate) return false
        return true
      })
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * 20, this.pageIndex * 20) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plan/capacity/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
</style>
